<div class="fc-header-wrapper">
  @if (headerEnabled && headerText) {
     <div [innerHTML]="headerHtml" ></div>
  }
</div>
<hr class="fc-header-divider">
